'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  cursor: pointer;\n  user-select: none;\n  ', '\n'], ['\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  cursor: pointer;\n  user-select: none;\n  ', '\n']);

var _rebass = require('rebass');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledSystem = require('styled-system');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// Add custom styles here
var CallToAction = (0, _styledComponents2.default)(_rebass.Button)(_templateObject, _styledSystem.width);

CallToAction.displayName = 'CallToAction';
CallToAction.defaultProps = {
  borderRadius: 4,
  px: 4,
  py: 3,
  is: 'a'
};

exports.default = CallToAction;